import type { Messages } from './en';

/** हिन्दी (India). Same keys as en.ts; placeholders like {name} stay as they are. */
export const hi: Messages = {
  'common.retry': 'फिर से कोशिश करें',
  'common.save': 'सेव करें',
  'common.saving': 'सेव हो रहा है…',
  'common.cancel': 'रद्द करें',
  'common.back': 'वापस',
  'common.edit': 'बदलें',
  'common.delete': 'हटाएँ',
  'common.keep': 'रखें',
  'common.discard': 'छोड़ें',
  'common.change': 'बदलें',
  'common.draftRestored': 'पिछली बार जो लिखा था, हमने संभाल कर रखा है।',
  'common.draftSaved': 'ड्राफ्ट सेव हो गया',
  'common.wrong': 'कुछ गड़बड़ हो गई। फिर से कोशिश करें।',
  'common.supportRef': 'यह कोड सपोर्ट को बताएँ',
  'common.copyRef': 'कोड कॉपी करें',
  'common.refCopied': 'कोड कॉपी हो गया',
  'common.offline': 'आप ऑफलाइन हैं। आख़िरी बार लोड हुआ दिखा रहे हैं।',
  'common.unreachable': 'Capsico से जुड़ नहीं पा रहे',
  'common.unreachableBody': 'अपना इंटरनेट कनेक्शन देखें।',

  'nav.home': 'होम',
  'nav.search': 'खोजें',
  'nav.account': 'अकाउंट',

  'location.deliverTo': 'डिलीवरी यहाँ',
  'location.choose': 'डिलीवरी की जगह चुनें',
  'location.useCurrent': 'मेरी अभी की लोकेशन लें',
  'location.locating': 'आपको ढूँढ रहे हैं…',
  'location.denied': 'लोकेशन बंद है। इसे चालू करें, या नीचे अपना शहर चुनें।',
  'location.unavailable': 'आपकी लोकेशन नहीं मिल पाई। नीचे अपना शहर चुनें।',
  'location.saved': 'सेव किए पते',
  'location.towns': 'या अपना शहर चुनें',
  'location.addAddress': 'नया पता जोड़ें',
  'location.signInToSave': 'पते सेव करने के लिए साइन इन करें',
  'location.current': 'अभी की लोकेशन',
  'location.townCentre': '{town} (शहर का बीच)',
  'location.setFirst': 'बताइए कहाँ डिलीवर करें, हम आसपास खुले रेस्टोरेंट दिखाएँगे।',
  'location.notServed': 'यहाँ अभी डिलीवरी नहीं',

  'signin.title': 'भूख लगी? साइन इन करें 🍛',
  'signin.subtitle': 'अपना मोबाइल नंबर डालें। हम 6 अंकों का कोड भेजेंगे।',
  'signin.phone': 'मोबाइल नंबर',
  'signin.sendCode': 'कोड भेजें',
  'signin.codeTitle': '{sentTo} पर भेजा कोड डालें',
  'signin.code': '6 अंकों का कोड',
  'signin.verify': 'पुष्टि करें',
  'signin.resendIn': '{seconds} सेकंड में दोबारा भेजें',
  'signin.resend': 'कोड दोबारा भेजें',
  'signin.changeNumber': 'नंबर बदलें',
  'signin.smsDelayed': 'SMS देर से आ रहा है। न आए तो Capsico सपोर्ट से कोड माँगें।',
  'signin.terms': 'आगे बढ़कर आप हमारी शर्तें और प्राइवेसी पॉलिसी मानते हैं।',
  'signin.browse': 'बस देख रहे हैं — अभी छोड़ें',
  'signin.enterPhone': 'अपना मोबाइल नंबर डालें',
  'signin.enterCode': '6 अंकों का कोड डालें',
  'turnstile.label': 'सुरक्षा जाँच',
  'turnstile.required': 'कृपया ऊपर दी गई जाँच पूरी करें और फिर से कोशिश करें।',
  'turnstile.failed': 'हम पुष्टि नहीं कर पाए कि आप इंसान हैं। कृपया जाँच फिर से करें।',

  'profile.title': 'थोड़ा अपने बारे में',
  'profile.subtitle': 'ताकि हम सही खाना दिखाएँ और आपको नाम से बुलाएँ।',
  'profile.name': 'आपका नाम',
  'profile.namePlaceholder': 'जैसे आशा वर्मा',
  'profile.diet': 'आप क्या खाते हैं?',
  'profile.veg': 'सिर्फ़ शाकाहारी',
  'profile.nonVeg': 'शाकाहारी और मांसाहारी',
  'profile.email': 'ईमेल (ज़रूरी नहीं)',
  'profile.emailPlaceholder': 'बिल के लिए, स्पैम कभी नहीं',
  'profile.birthday': 'जन्मदिन (ज़रूरी नहीं)',
  'profile.birthdayHint': 'आपके दिन पर एक ट्रीट 🎂',
  'profile.language': 'ऐप की भाषा',
  'profile.save': 'सेव करें और आगे बढ़ें',
  'profile.saved': 'प्रोफ़ाइल सेव हो गई',
  'profile.nameRequired': 'अपना नाम बताएँ (कम से कम 2 अक्षर)',
  'profile.dietRequired': 'शाकाहारी या मांसाहारी चुनें',
  'profile.edit': 'प्रोफ़ाइल बदलें',

  'address.title': 'पता जोड़ें',
  'address.editTitle': 'पता बदलें',
  'address.pinHint': 'मैप खिसकाकर पिन अपने गेट पर रखें',
  'address.house': 'मकान / फ्लैट नंबर',
  'address.floor': 'मंज़िल (ज़रूरी नहीं)',
  'address.area': 'गली और इलाका',
  'address.landmark': 'पास की कोई पहचान (ज़रूरी नहीं)',
  'address.landmarkPlaceholder': 'जैसे मंदिर के सामने',
  'address.instructions': 'राइडर के लिए नोट (ज़रूरी नहीं)',
  'address.instructionsPlaceholder': 'जैसे घंटी दो बार बजाएँ, कुत्ता काटता नहीं',
  'address.saveAs': 'इस नाम से सेव करें',
  'address.home': 'घर',
  'address.work': 'ऑफ़िस',
  'address.other': 'और',
  'address.otherName': 'इस जगह का नाम',
  'address.otherPlaceholder': 'जैसे हॉस्टल, मम्मी का घर',
  'address.someoneElse': 'किसी और के लिए ऑर्डर?',
  'address.receiverName': 'उनका नाम',
  'address.receiverPhone': 'उनका मोबाइल नंबर',
  'address.gatePhoto': 'गेट की फ़ोटो',
  'address.gatePhotoHint': 'राइडर को पहली बार में ही रास्ता मिल जाएगा',
  'address.addPhoto': 'फ़ोटो जोड़ें',
  'address.replace': 'बदलें',
  'address.remove': 'हटाएँ',
  'address.voiceNote': 'आवाज़ में रास्ता',
  'address.voiceHint': '60 सेकंड तक — "चाय की दुकान के बाद बाएँ मुड़ें…"',
  'address.record': 'रिकॉर्ड करें',
  'address.stop': 'रोकें',
  'address.recording': 'रिकॉर्ड हो रहा है {time}',
  'address.uploading': 'अपलोड {percent}%',
  'address.micDenied': 'माइक बंद है। रास्ता रिकॉर्ड करने के लिए अनुमति दें।',
  'address.makeDefault': 'इसे मेरा मुख्य पता बनाएँ',
  'address.save': 'पता सेव करें',
  'address.saved': 'पता सेव हो गया',
  'address.deleted': 'पता हटा दिया',
  'address.deleteConfirm': 'यह पता हटाएँ?',
  'address.default': 'मुख्य',
  'address.setDefault': 'मुख्य बनाएँ',
  'address.notServed': 'यहाँ अभी डिलीवरी नहीं होती',
  'address.none': 'अभी कोई पता सेव नहीं',
  'address.noneBody': 'घर और ऑफ़िस एक बार सेव करें — ऑर्डर जल्दी होगा।',

  'vote.title': 'Capsico यहाँ अभी नहीं… अभी तक 🛵',
  'vote.body': 'इस इलाके से हर वोट इसे हमारी लॉन्च लिस्ट में ऊपर लाता है।',
  'vote.cta': 'Capsico यहाँ लाओ',
  'vote.voted': 'वोट गिना गया! हम आएँगे तो आपको बताएँगे।',
  'vote.already': 'आप इस इलाके के लिए वोट कर चुके हैं। शुक्रिया!',
  'vote.nearby': 'आपके पास {count} लोग Capsico चाहते हैं',
  'vote.notify': 'लॉन्च पर ख़बर के लिए फ़ोन नंबर (ज़रूरी नहीं)',
  'vote.otherPlace': 'कोई और जगह देखें',

  'account.title': 'अकाउंट',
  'account.signedOutTitle': 'आपका खाना, आपके हिसाब से',
  'account.signedOutBody': 'पते सेव करने और खाना मँगाने के लिए साइन इन करें।',
  'account.signIn': 'साइन इन',
  'account.addresses': 'सेव किए पते',
  'account.language': 'भाषा',
  'account.theme': 'दिखावट',
  'account.themeAuto': 'अपने आप (रात 10 बजे के बाद डार्क)',
  'account.themeLight': 'लाइट',
  'account.themeDark': 'डार्क',
  'account.signOut': 'साइन आउट',
  'account.version': 'Capsico {version}',

  'home.searchPlaceholder': '"बिरयानी" या रेस्टोरेंट खोजें',
  'home.promiseTitle1': 'प्लेटफ़ॉर्म फ़ीस ज़ीरो',
  'home.promiseBody1': 'आप सिर्फ़ खाना और डिलीवरी देते हैं। कुछ छुपा नहीं।',
  'home.promiseTitle2': 'मेन्यू का दाम = ऐप का दाम',
  'home.promiseBody2': 'काउंटर वाला ही दाम। हर हफ़्ते जाँचा जाता है।',
  'home.promiseTitle3': 'आपका शहर, आपकी रसोई',
  'home.promiseBody3': 'लोकल पसंदीदा, लोकल राइडर से।',
  'home.cuisines': 'खाने के प्रकार',
  'home.mind': 'आज क्या खाने का मन है?',
  'home.top': 'आपके पास के टॉप रेस्टोरेंट',
  'home.emptyTitle': 'रसोई गर्म हो रही है 🔥',
  'home.emptyBody': 'अभी यहाँ कोई रेस्टोरेंट ऑर्डर नहीं ले रहा। जल्द देखें।',
  'home.closed': 'बंद',
  'home.newBadge': 'नया',
  'home.legend': 'लोकल लेजेंड',
  'home.forTwo': 'दो लोगों के लिए {amount}',
  'home.places': '{count} जगहें',

  'search.placeholder': 'डिश या रेस्टोरेंट खोजें',
  'search.sort': 'क्रम',
  'search.filterVeg': 'शाकाहारी',
  'search.filterPureVeg': 'शुद्ध शाकाहारी',
  'search.filterRating': 'रेटिंग 4+',
  'search.filterFast': 'जल्दी डिलीवरी',
  'search.filterNew': 'नया',
  'search.filterOpen': 'अभी खुले',
  'search.results': '{count} रेस्टोरेंट',
  'search.noneTitle': 'कुछ नहीं मिला',
  'search.noneBody': 'कोई और डिश का नाम आज़माएँ, या फ़िल्टर हटाएँ।',
  'search.clear': 'फ़िल्टर हटाएँ',
  'search.matched': 'इसमें है {dishes}',
  'search.start': 'कोई डिश, खाने का प्रकार या रेस्टोरेंट खोजें',

  'restaurant.licence': '{kind} लाइसेंस {number}',
  'restaurant.vegOnly': 'सिर्फ़ शाकाहारी',
  'restaurant.searchMenu': 'मेन्यू में खोजें',
  'restaurant.bestseller': 'बेस्टसेलर',
  'restaurant.customisable': 'अपने हिसाब से',
  'restaurant.add': 'जोड़ें',
  'restaurant.menuEmpty': 'मेन्यू अपडेट हो रहा है। जल्द देखें।',
  'restaurant.noMatch': '"{query}" से कोई डिश नहीं मिली',
  'restaurant.closed': 'अभी बंद है',
  'restaurant.notFound': 'यह रेस्टोरेंट उपलब्ध नहीं है',
  'restaurant.items': '{count} आइटम',

  'customise.size': 'साइज़ चुनें',
  'customise.required': 'ज़रूरी',
  'customise.optional': 'ज़रूरी नहीं',
  'customise.upTo': '{max} तक चुनें',
  'customise.exactly': '{count} चुनें',
  'customise.between': '{min} से {max} चुनें',
  'customise.pick': '{count} चुनें',
  'customise.total': 'आइटम का कुल',
  'customise.addToCart': 'आइटम जोड़ें · {price}',
  'customise.cartSoon': 'ऑर्डर बहुत जल्द शुरू — कार्ट अगले अपडेट में आ रहा है 🙌',
  'customise.incomplete': 'ज़रूरी विकल्प पूरे करें',
  'cart.items': '{count} आइटम',
  'cart.item': '1 आइटम',
  'cart.view': 'कार्ट देखें',
  'cart.added': 'कार्ट में जुड़ गया 🛒',
  'cart.full': 'कार्ट भर गया — ज़्यादा से ज़्यादा 30 अलग डिश',
  'cart.replaceTitle': 'नया कार्ट शुरू करें?',
  'cart.replaceBody': 'आपके कार्ट में {name} की डिश हैं। इस रेस्टोरेंट से नया कार्ट शुरू करें?',
  'cart.replaceYes': 'नया कार्ट',
  'cart.replaceNo': 'पुराना रखें',
  'cart.empty': 'आपका कार्ट खाली है',
  'cart.emptyHint': 'पास के किसी रेस्टोरेंट से कुछ स्वादिष्ट चुनिए 😋',
  'cart.browse': 'खाना ढूँढें',
  'checkout.title': 'चेकआउट',
  'checkout.addMore': 'और आइटम जोड़ें',
  'checkout.kitchenNote': 'रेस्टोरेंट के लिए नोट',
  'checkout.kitchenNoteHint': 'जैसे कम मसाला, प्याज़ नहीं',
  'checkout.cutlery': 'चम्मच भेजें',
  'checkout.cutleryHint': 'डिफ़ॉल्ट बंद — धरती के लिए अच्छा 🌱',
  'checkout.offers': 'ऑफ़र और कूपन',
  'checkout.viewOffers': 'सभी ऑफ़र देखें',
  'checkout.applied': '{code} लग गया',
  'checkout.youSave': 'आपकी बचत {amount}',
  'checkout.remove': 'हटाएँ',
  'checkout.apply': 'लगाएँ',
  'checkout.enterCode': 'कूपन कोड डालें',
  'checkout.funding.restaurant': 'रेस्टोरेंट का ऑफ़र',
  'checkout.funding.capsico': 'Capsico का ऑफ़र',
  'checkout.funding.shared': 'रेस्टोरेंट + Capsico का ऑफ़र',
  'checkout.bill': 'बिल',
  'checkout.toPay': 'कुल भुगतान',
  'checkout.savedTotal': 'इस ऑर्डर पर {amount} बचाए 🎉',
  'checkout.why': 'यह फ़ीस क्यों?',
  'checkout.gotIt': 'समझ गए',
  'checkout.tip': 'राइडर को टिप दें',
  'checkout.tipHint': 'पूरी टिप राइडर को जाती है',
  'checkout.noTip': 'टिप नहीं',
  'checkout.deliverTo': 'डिलीवरी पता',
  'checkout.change': 'बदलें',
  'checkout.pickAddress': 'डिलीवरी पता चुनें',
  'checkout.addAddress': 'नया पता जोड़ें',
  'checkout.needAddress': 'ऑर्डर के लिए पता जोड़ें',
  'checkout.someoneElse': 'किसी और के लिए ऑर्डर?',
  'checkout.receiverName': 'लेने वाले का नाम',
  'checkout.receiverPhone': 'लेने वाले का फ़ोन',
  'checkout.phoneError': 'सही फ़ोन नंबर डालें',
  'checkout.when': 'कब',
  'checkout.now': 'अभी',
  'checkout.prepaidOnly': 'शेड्यूल ऑर्डर का भुगतान ऑनलाइन होगा',
  'checkout.payment': 'भुगतान',
  'checkout.cod': 'कैश ऑन डिलीवरी',
  'checkout.test': 'टेस्ट भुगतान (केवल डेवलपमेंट)',
  'checkout.place': 'ऑर्डर करें',
  'checkout.placing': 'ऑर्डर हो रहा है…',
  'checkout.signIn': 'ऑर्डर के लिए साइन इन करें',
  'checkout.pricesChanged': 'दाम बदल गए — बिल देखकर फिर से ऑर्डर करें',
  'checkout.placed': 'ऑर्डर हो गया! 🎉',
  'checkout.freeDelivery': 'इस ऑर्डर पर फ्री डिलीवरी 🎉',
  'checkout.freeLeft': 'इसके बाद {count} और फ्री डिलीवरी ऑर्डर',
  'checkout.minimum': 'ऑर्डर के लिए {amount} और जोड़ें',
  'checkout.unavailable': 'बिल नहीं खुल पाया',
  'orders.title': 'आपके ऑर्डर',
  'orders.empty': 'अभी तक कोई ऑर्डर नहीं',
  'orders.emptyHint': 'पहला ऑर्डर बस एक टैप दूर 🍛',
  'orders.placedTitle': 'ऑर्डर हो गया! 🎉',
  'orders.placedBody': '{name} को आपका ऑर्डर मिल गया',
  'orders.number': 'ऑर्डर #{number}',
  'orders.eta': '{eta} में पहुँचेगा',
  'orders.scheduledFor': '{time} के लिए शेड्यूल',
  'orders.trackSoon': 'लाइव ट्रैकिंग अगले अपडेट में',
  'orders.backHome': 'होम पर जाएँ',
  'orders.payCash': 'दरवाज़े पर {amount} नकद दें',
  'orders.paid': 'भुगतान हो गया',
  'orders.refunded': 'रिफ़ंड हो गया',
  'orders.items': 'आइटम',
  'orders.deliveringTo': 'डिलीवरी',
  'orders.cancelledBecause': 'रद्द: {reason}',
  'orders.notFound': 'ऑर्डर नहीं मिला',
  'stage.scheduled': 'शेड्यूल',
  'stage.placed': 'रेस्टोरेंट की पुष्टि बाकी',
  'stage.preparing': 'बन रहा है 🍳',
  'stage.ready': 'पिकअप के लिए तैयार',
  'stage.on_the_way': 'रास्ते में 🛵',
  'stage.delivered': 'पहुँच गया',
  'stage.cancelled': 'रद्द',
  'account.orders': 'आपके ऑर्डर',
  'common.today': 'आज',
  'common.tomorrow': 'कल',
  'stage.awaiting_payment': 'पेमेंट का इंतज़ार',
  'account.wallet': 'Capsico Money',
  'pay.wallet': 'Capsico Money',
  'pay.walletUsing': 'इस ऑर्डर पर {amount} इस्तेमाल होंगे',
  'pay.walletOff': 'बैलेंस इस्तेमाल करने के लिए चालू करें',
  'pay.walletExpires': '{amount} की मियाद {date} को ख़त्म',
  'pay.walletApplied': '{amount} Capsico Money लगा',
  'pay.payAmount': '{amount} चुकाएँ',
  'pay.payWallet': 'Capsico Money से चुकाएँ',
  'pay.secure': '100% सुरक्षित पेमेंट',
  'pay.method.cod': 'कैश ऑन डिलीवरी',
  'pay.method.test': 'टेस्ट पेमेंट (सिर्फ़ डेवलपमेंट)',
  'pay.method.wallet': 'Capsico Money',
  'pay.method.upi': 'UPI',
  'pay.method.card': 'क्रेडिट / डेबिट कार्ड',
  'pay.method.netbanking': 'नेटबैंकिंग',
  'pay.method.esewa': 'eSewa',
  'pay.method.khalti': 'Khalti',
  'pay.method.fonepay': 'Fonepay QR',
  'pay.method.imepay': 'IME Pay',
  'pay.method.connectips': 'ConnectIPS',
  'payment.paid': 'पेमेंट मिल गया 🎉',
  'payment.notFinished': 'पेमेंट पूरा नहीं हुआ। यहीं से फिर से चुकाएँ।',
  'payment.notYet': 'अभी तक नहीं मिला — कुछ सेकंड रुकें।',
  'payment.failed': 'पेमेंट नहीं हो पाया',
  'payment.cancelled': 'ऑर्डर रद्द हो गया',
  'payment.qrCopied': 'कोड कॉपी हो गया',
  'payment.gatewayDown': 'पेमेंट पेज नहीं खुला। इंटरनेट देखें और फिर कोशिश करें।',
  'payment.waitingTitle': 'अपना पेमेंट पूरा करें',
  'payment.waitingBody': '{amount} चुकाएँ — पैसा आते ही रेस्टोरेंट खाना बनाना शुरू करेगा।',
  'payment.payNow': 'अभी चुकाएँ',
  'payment.payAnother': 'दूसरे तरीके से चुकाएँ',
  'payment.cancelOrder': 'ऑर्डर रद्द करें',
  'payment.keepOrder': 'ऑर्डर रखें',
  'payment.cancelTitle': 'यह ऑर्डर रद्द करें?',
  'payment.cancelBody':
    'अगर कोई पैसा कटा है, तो वापस मिलेगा। इस ऑर्डर पर लगा Capsico Money आपके बैलेंस में लौट आएगा।',
  'payment.pickMethod': 'पेमेंट का तरीका चुनें',
  'payment.qrTitle': '{amount} चुकाने के लिए स्कैन करें',
  'payment.qrBody':
    'अपना बैंक या वॉलेट ऐप खोलें, यह Fonepay कोड स्कैन या पेस्ट करके चुकाएँ। पेमेंट हम ख़ुद पकड़ लेंगे।',
  'payment.qrCopy': 'कोड कॉपी करें',
  'payment.qrWaiting': 'आपके पेमेंट का इंतज़ार…',
  'payment.qrPaid': 'मैंने चुका दिया',
  'payment.partlyRefunded': '{amount} वापस किए गए',
  'payment.failedStatus': 'पेमेंट नहीं हो पाया',
  'payment.walletUsed': '{amount} Capsico Money से चुकाए',
  'payment.returnTitle': 'पेमेंट',
  'payment.confirming': 'आपका पेमेंट पक्का कर रहे हैं…',
  'payment.confirmingBody': 'रुकिए — हम {gateway} से पक्का कर रहे हैं। ऐप बंद न करें।',
  'payment.slow': 'इसमें सामान्य से ज़्यादा समय लग रहा है। ऑर्डर पेज ख़ुद अपडेट हो जाएगा।',
  'payment.viewOrder': 'ऑर्डर देखें',
  'payment.failedBody':
    'अगर पैसा कटा है तो अपने-आप वापस आएगा। फिर कोशिश करें या दूसरा तरीका चुनें।',
  'payment.tryAgain': 'फिर से कोशिश करें',
  'payment.returnBroken': 'यह पेमेंट नहीं पढ़ पाए',
  'payment.returnBrokenBody': "स्थिति देखने के लिए 'आपके ऑर्डर' से ऑर्डर खोलें।",
  'refund.title': 'रिफंड',
  'refund.toWallet': 'Capsico Money में',
  'refund.toSource': 'आपके मूल पेमेंट तरीके में',
  'refund.status.awaiting_choice': 'कहाँ भेजें, चुनें',
  'refund.status.processing': 'प्रोसेस हो रहा है · 3–5 दिन',
  'refund.status.manual': 'प्रोसेस हो रहा है · 3–5 दिन',
  'refund.status.done': 'वापस हो गया',
  'refund.status.failed': 'देरी — सपोर्ट आपसे संपर्क करेगा',
  'refund.choiceTitle': '{amount} कहाँ भेजें?',
  'refund.choiceWallet': 'अभी Capsico Money में',
  'refund.choiceWalletBonus': 'अभी Capsico Money में (+{amount} बोनस)',
  'refund.choiceWalletHint': 'तुरंत — अगले ऑर्डर पर इस्तेमाल करें',
  'refund.choiceSource': 'मूल तरीके में वापस',
  'refund.choiceSourceHint': '3–5 दिन लगते हैं',
  'refund.chooseBy': '{time} तक चुनें, वरना Capsico Money में जाएगा',
  'refund.saved': 'हो गया — रिफंड आ रहा है',
  'refund.reason.restaurant_rejected': 'रेस्टोरेंट ऑर्डर नहीं ले सका',
  'refund.reason.not_accepted': 'रेस्टोरेंट ने समय पर ऑर्डर नहीं लिया',
  'refund.reason.ops_cancelled': 'Capsico ने रद्द किया',
  'refund.reason.customer_cancelled': 'आपने ऑर्डर रद्द किया',
  'refund.reason.payment_timeout': 'पेमेंट समय पर पूरा नहीं हुआ',
  'refund.reason.complaint': 'शिकायत मंज़ूर',
  'refund.reason.goodwill': 'Capsico की ओर से क्रेडिट',
  'invoice.title': 'टैक्स इनवॉइस',
  'invoice.food': 'खाने का इनवॉइस',
  'invoice.fees': 'Capsico शुल्क इनवॉइस',
  'invoice.download': 'डाउनलोड',
  'invoice.failed': 'इनवॉइस डाउनलोड नहीं हुआ। फिर कोशिश करें।',
  'wallet.title': 'Capsico Money',
  'wallet.balance': 'Capsico Money बैलेंस',
  'wallet.heroHint': 'किसी भी ऑर्डर पर इस्तेमाल करें — चेकआउट पर लगता है',
  'wallet.storeCredit': 'सिर्फ़ स्टोर क्रेडिट — टॉप-अप नहीं। हर क्रेडिट की एक्सपायरी होती है।',
  'wallet.credits': 'आपके क्रेडिट',
  'wallet.expiresOn': '{date} को ख़त्म',
  'wallet.left': '{total} में से {left} बचे',
  'wallet.source.refund': 'रिफंड',
  'wallet.source.complaint_bonus': 'Capsico Money चुनने का बोनस',
  'wallet.source.goodwill': 'Capsico की ओर से',
  'wallet.source.compensation': 'माफ़ी क्रेडिट',
  'wallet.source.referral': 'दोस्त को बुलाने का इनाम',
  'wallet.source.cashback': 'कैशबैक',
  'wallet.source.winback': 'वापसी क्रेडिट',
  'wallet.history': 'हिस्ट्री',
  'wallet.entry.credit': 'जोड़ा गया',
  'wallet.entry.debit': 'ऑर्डर पर इस्तेमाल',
  'wallet.entry.reverse': 'वापस आया',
  'wallet.entry.expire': 'मियाद ख़त्म',
  'wallet.empty': 'अभी कोई Capsico Money नहीं',
  'wallet.emptyHint': 'रिफंड और Capsico के क्रेडिट यहाँ दिखेंगे।',
  'wallet.pending': 'आपकी पसंद का इंतज़ार कर रहे रिफंड',
  'wallet.noHistory': 'अभी यहाँ कुछ नहीं',
  'wallet.country.IN': 'भारत ₹',
  'wallet.country.NP': 'नेपाल Rs',
  'checkout.leaveAtDoor': 'दरवाज़े पर छोड़ दें',
  'checkout.leaveAtDoorHint': 'न घंटी, न कोड — राइडर छोड़कर आपको फ़ोटो भेजेगा 📸',
  'track.stage.placed': 'ऑर्डर हो गया',
  'track.stage.accepted': 'रेस्टोरेंट ने ऑर्डर ले लिया',
  'track.stage.preparing': 'आपका खाना बन रहा है 🍳',
  'track.stage.ready': 'खाना तैयार है',
  'track.stage.rider_assigned': 'राइडर रेस्टोरेंट जा रहा है',
  'track.stage.picked_up': 'पिकअप हो गया — रास्ते में 🛵',
  'track.stage.nearby': 'राइडर पास में है',
  'track.stage.delivered': 'डिलीवर हो गया 🎉',
  'track.stage.cancelled': 'ऑर्डर रद्द हो गया',
  'track.step.placed': 'ऑर्डर हुआ',
  'track.step.accepted': 'स्वीकार',
  'track.step.preparing': 'बन रहा है',
  'track.step.ready': 'तैयार',
  'track.step.rider_assigned': 'राइडर तय',
  'track.step.picked_up': 'पिकअप',
  'track.step.nearby': 'पास में',
  'track.step.delivered': 'डिलीवर',
  'track.step.cancelled': 'रद्द',
  'track.sub.placed': '{name} के जवाब का इंतज़ार',
  'track.sub.accepted': '{name} के पास आपका ऑर्डर है',
  'track.sub.preparing': '{name} ताज़ा बना रहा है',
  'track.sub.ready': 'पैक है, राइडर का इंतज़ार',
  'track.sub.findingRider': 'रेस्टोरेंट के पास राइडर ढूँढ रहे हैं…',
  'track.sub.rider_assigned': '{rider} रेस्टोरेंट की ओर जा रहे हैं',
  'track.sub.picked_up': '{rider} आपकी ओर आ रहे हैं',
  'track.sub.nearby': '{rider} बस पहुँचने वाले हैं — फ़ोन पास रखें',
  'track.sub.delivered': 'खाने का मज़ा लीजिए!',
  'track.etaArriving': 'पहुँचेगा',
  'track.etaRange': '{from}–{to} मिनट',
  'track.etaMinutes': '{minutes} मिनट',
  'track.late': 'थोड़ी देरी',
  'track.lateBody': 'माफ़ कीजिए, वादे से ज़्यादा समय लग रहा है। हम इस पर लगे हैं।',
  'track.lateApology': 'देरी के लिए माफ़ी 🙏 आपके वॉलेट में Capsico Money जोड़ दिया है।',
  'track.reconnecting': 'लाइव अपडेट रुके हैं। हर 15 सेकंड में ताज़ा कर रहे हैं…',
  'track.mapLabel': 'आपकी डिलीवरी का नक्शा',
  'track.pinRestaurant': 'रेस्टोरेंट',
  'track.pinHome': 'आपकी जगह',
  'track.pinRider': 'आपका राइडर',
  'track.recenter': 'नक्शे पर सब दिखाएँ',
  'track.steps': 'ऑर्डर की प्रगति',
  'track.rider.call': 'राइडर को कॉल करें',
  'track.rider.chat': 'राइडर से चैट करें',
  'track.rider.unread': '{count} नए मैसेज',
  'track.rider.masked': 'कॉल Capsico से होकर जाती है — आपका नंबर निजी रहता है।',
  'track.vehicle.walker': 'पैदल',
  'track.vehicle.cyclist': 'साइकिल',
  'track.vehicle.motorbike': 'बाइक',
  'track.callUnavailable': 'अभी कॉल नहीं हो सकती। चैट करें या Capsico सपोर्ट को कॉल करें।',
  'track.code.title': 'डिलीवरी कोड',
  'track.code.hint': 'यह कोड सिर्फ़ दरवाज़े पर राइडर को बताएँ।',
  'track.code.locked': 'कई बार गलत कोड डला। Capsico सपोर्ट राइडर की मदद करेगा।',
  'track.code.failed': 'कोड लोड नहीं हुआ।',
  'track.leaveAtDoor': 'दरवाज़े पर छोड़ना है — राइडर रखकर फ़ोटो भेजेगा।',
  'track.proof.title': 'दरवाज़े पर रखा गया',
  'track.proof.caption': 'राइडर की ली हुई फ़ोटो। 30 दिन तक रहेगी।',
  'chat.title': '{name} से चैट',
  'chat.placeholder': 'मैसेज लिखें',
  'chat.send': 'भेजें',
  'chat.sending': 'भेज रहे हैं…',
  'chat.closed': 'ऑर्डर डिलीवर होते ही चैट बंद हो जाती है।',
  'chat.empty': 'हाय बोलें या कोई क्विक रिप्लाई चुनें 👋',
  'chat.failed': 'मैसेज नहीं गया। फिर से कोशिश करें।',
  'chat.quick.at_gate': 'मैं गेट पर हूँ',
  'chat.quick.please_call': 'कृपया कॉल करें',
  'chat.quick.coming_down': 'नीचे आ रहा हूँ',
  'chat.quick.wait_two': 'कृपया 2 मिनट रुकें',
  'chat.quick.on_the_way': 'आ रहा हूँ',
  'chat.quick.reached': 'मैं पहुँच गया',

  // W16 Help + chat
  'help.title': 'मदद और सहायता',
  'help.orderHelp': 'इस ऑर्डर में मदद',
  'help.myTickets': 'आपकी चैट',
  'help.noTickets': 'अभी कोई चैट नहीं',
  'help.noTicketsBody': 'कुछ गड़बड़ है? चैट शुरू करें — हम ज़्यादातर मिनटों में सुलझा देते हैं।',
  'help.recentOrders': 'हाल के ऑर्डर में मदद',
  'help.otherTopics': 'कुछ और',
  'help.otherBody': 'अकाउंट, पेमेंट या कुछ भी जो किसी एक ऑर्डर का नहीं',
  'help.deskOpen': 'हमारी टीम ऑनलाइन है',
  'help.deskClosed': 'हमारी टीम अभी ऑफ़लाइन है',
  'help.botNote': 'हमारा असिस्टेंट तुरंत जवाब देता है, रात में भी। {hours}',
  'help.loadFailed': 'मदद लोड नहीं हुई',
  'help.newTitle': 'क्या गड़बड़ हुई?',
  'help.newTitleOrder': 'ऑर्डर {number} में मदद',
  'help.reasonLabel': 'कारण चुनें',
  'help.openExisting': 'इसके बारे में आपकी चैट पहले से खुली है',
  'help.openChat': 'चैट खोलें',
  'help.items': 'कौन-से आइटम?',
  'help.itemsHint': 'जो नहीं आया या गलत आया, वो चुनें',
  'help.itemOf': '{ordered} में से {picked}',
  'help.less': 'एक कम',
  'help.more': 'एक और',
  'help.photos': 'फ़ोटो जोड़ें',
  'help.photosHint': 'साफ़ फ़ोटो से हम जल्दी ठीक कर पाते हैं ({max} तक)',
  'help.addPhoto': 'फ़ोटो जोड़ें',
  'help.removePhoto': 'फ़ोटो हटाएँ',
  'help.photoFailed': 'नहीं हुआ',
  'help.photoType': 'JPG, PNG या WebP फ़ोटो लगाएँ',
  'help.photoSize': 'फ़ोटो बहुत बड़ी है (अधिकतम 8 MB)',
  'help.photoMany': 'आप {max} फ़ोटो तक जोड़ सकते हैं',
  'help.photoUpload': 'फ़ोटो अपलोड नहीं हुई। फिर से कोशिश करें।',
  'help.note': 'कुछ और? (वैकल्पिक)',
  'help.notePlaceholder': 'बताइए क्या हुआ',
  'help.needItems': 'कम से कम एक आइटम चुनें',
  'help.needPhoto': 'आगे बढ़ने के लिए फ़ोटो जोड़ें',
  'help.uploading': 'फ़ोटो अपलोड होने दें',
  'help.submit': 'चैट शुरू करें',
  'help.createFailed': 'चैट नहीं खुल पाई। फिर से कोशिश करें।',
  'help.group.order': 'खाना और आइटम',
  'help.group.delivery': 'डिलीवरी',
  'help.group.payment': 'पेमेंट और रिफ़ंड',
  'help.group.conduct': 'व्यवहार',
  'help.group.partner': 'रेस्टोरेंट पार्टनर',
  'help.group.rider': 'राइडर',
  'help.group.other': 'अन्य',
  'help.status.bot': 'असिस्टेंट के साथ',
  'help.status.queued': 'एजेंट का इंतज़ार',
  'help.status.assigned': 'एजेंट जवाब दे रहे हैं',
  'help.status.waiting_customer': 'आपका इंतज़ार',
  'help.status.resolved': 'सुलझ गया',
  'help.status.closed': 'बंद',
  'help.chatTitle': 'चैट {number}',
  'help.orderLabel': 'ऑर्डर {number}',
  'help.bot': 'Capsico असिस्टेंट',
  'help.agent': 'Capsico सपोर्ट',
  'help.team': 'Capsico',
  'help.empty': 'बताइए क्या हुआ, बाकी हम संभाल लेंगे।',
  'help.placeholder': 'मैसेज लिखें',
  'help.send': 'भेजें',
  'help.attach': 'फ़ोटो जोड़ें',
  'help.sending': 'भेजा जा रहा है…',
  'help.sendFailed': 'मैसेज नहीं गया। फिर से कोशिश करें।',
  'help.actionFailed': 'यह नहीं हुआ। फिर से कोशिश करें।',
  'help.talkToAgent': 'एजेंट से बात करें',
  'help.agentAsked': 'हो गया — एजेंट जल्द जुड़ेंगे',
  'help.queue': 'आप कतार में #{n} पर हैं',
  'help.agentReplying': 'Capsico से {name} आपकी मदद कर रहे हैं',
  'help.language': 'चैट की भाषा',
  'help.reconnecting': 'फिर से जुड़ रहे हैं… हर 15 सेकंड अपडेट',
  'help.closedNotice': 'यह चैट बंद है। मदद चाहिए तो नई चैट शुरू करें।',
  'help.refunds': 'इस चैट के रिफ़ंड',
  'help.rateTitle': 'हमने कैसा किया?',
  'help.rateBody': 'इस चैट को रेट करें — इससे हम बेहतर होते हैं।',
  'help.star': '5 में से {n}',
  'help.rateComment': 'कुछ जोड़ना है? (वैकल्पिक)',
  'help.rateSubmit': 'रेटिंग भेजें',
  'help.rated': 'रेटिंग के लिए शुक्रिया!',
  'help.ratedLine': 'आपने इस चैट को {score} / 5 दिया',
  'help.notFound': 'चैट नहीं मिली',
  'help.callAsked': 'कॉल का अनुरोध हो गया — हम जल्द कॉल करेंगे',
  'help.requestCall': 'कॉल का अनुरोध करें',
  'help.callRequested': '{time} पर कॉल का अनुरोध किया',
  'help.unread': 'नया जवाब',
  'rate.title': 'अपना ऑर्डर रेट करें',
  'rate.from': '{name} से',
  'rate.editTitle': 'अपनी रेटिंग बदलें',
  'rate.food': 'खाना कैसा था?',
  'rate.delivery': 'डिलीवरी कैसी थी?',
  'rate.star1': 'बहुत बुरा',
  'rate.star2': 'बुरा',
  'rate.star3': 'ठीक-ठाक',
  'rate.star4': 'अच्छा',
  'rate.star5': 'बहुत पसंद आया',
  'rate.starAria': '5 में से {n}',
  'rate.dishes': 'कौन-सी डिश पसंद आई?',
  'rate.like': '{name} पसंद आया',
  'rate.unlike': '{name} पसंद नहीं आया',
  'rate.text': 'दूसरों को बताएँ (वैकल्पिक)',
  'rate.textPlaceholder': 'क्या पसंद आया? क्या बेहतर हो सकता था?',
  'rate.count': '{n}/{max}',
  'rate.photos': 'फ़ोटो जोड़ें',
  'rate.photosHint': 'अपने खाने की 3 फ़ोटो तक',
  'rate.addPhoto': 'फ़ोटो जोड़ें',
  'rate.removePhoto': 'फ़ोटो हटाएँ',
  'rate.uploading': 'अपलोड हो रहा है {percent}%',
  'rate.photoFailed': 'अपलोड नहीं हुआ',
  'rate.submit': 'रेटिंग भेजें',
  'rate.save': 'बदलाव सेव करें',
  'rate.editUntil': 'आप इसे {time} तक बदल सकते हैं',
  'rate.thanks': 'रेटिंग के लिए धन्यवाद! 🙌',
  'rate.updated': 'रेटिंग अपडेट हो गई',
  'rate.changed': 'यह रेटिंग कहीं और बदली गई। हमने इसे फिर से लोड किया।',
  'rate.failed': 'आपकी रेटिंग नहीं गई। फिर से कोशिश करें।',
  'rate.badType': 'JPG, PNG या WebP फ़ोटो लगाएँ',
  'rate.tooBig': 'फ़ोटो बहुत बड़ी है (अधिकतम 8 MB)',
  'rate.tooMany': 'आप 3 फ़ोटो तक जोड़ सकते हैं',
  'rate.uploadFailed': 'एक फ़ोटो अपलोड नहीं हुई। उसे हटाकर फिर कोशिश करें।',
  'rate.blockTitle': 'हम यह रेटिंग नहीं ले सकते',
  'rate.block.not_delivered': 'ऑर्डर डिलीवर होने के बाद आप इसे रेट कर सकते हैं।',
  'rate.block.window_closed': 'इस ऑर्डर को रेट करने का समय निकल गया।',
  'rate.block.already_reviewed':
    'आप यह ऑर्डर पहले ही रेट कर चुके हैं — My reviews से बदल सकते हैं।',
  'rate.block.self_review': 'रेस्टोरेंट की अपनी टीम या फ़ोन से रेटिंग की अनुमति नहीं है।',
  'rate.block.self_order': 'यह ऑर्डर रेट नहीं किया जा सकता।',
  'rate.block.not_yours': 'यह ऑर्डर किसी दूसरे अकाउंट का है।',
  'rate.cardTitle': 'आपका ऑर्डर कैसा था?',
  'rate.cardBody': '{name} को रेट करें — बस 10 सेकंड',
  'rate.cardAction': 'अभी रेट करें',
  'rate.rateBy': '{time} तक रेट करें',
  'rate.yours': 'आपकी रेटिंग',
  'rate.foodShort': 'खाना',
  'rate.deliveryShort': 'डिलीवरी',
  'rate.stripTitle': 'अपने ऑर्डर रेट करें',
  'rate.stripOne': '{name} कैसा था?',
  'rate.stripMany': '{name} और {count} और',
  'rate.stripAction': 'रेट करें',
  'reviews.title': 'रेटिंग और रिव्यू',
  'reviews.new': 'नया',
  'reviews.newBody': 'अभी काफ़ी रेटिंग नहीं — पहले रेट करने वालों में बनें',
  'reviews.count': '{count} रेटिंग · पिछले 90 दिन',
  'reviews.seeAll': 'सभी रिव्यू देखें',
  'reviews.empty': 'अभी कोई रिव्यू नहीं',
  'reviews.emptyBody': 'ऑर्डर करें और पहला रिव्यू लिखें 🍛',
  'reviews.sort': 'रिव्यू क्रम',
  'reviews.sort.recent': 'नए',
  'reviews.sort.highest': 'सबसे ऊँची',
  'reviews.sort.lowest': 'सबसे कम',
  'reviews.sort.photos': 'फ़ोटो वाले',
  'reviews.reply': 'रेस्टोरेंट का जवाब',
  'reviews.liked': 'पसंद: {dishes}',
  'reviews.hygiene.green': 'स्वच्छता: बहुत अच्छी',
  'reviews.hygiene.amber': 'स्वच्छता: अच्छी',
  'reviews.loadMore': 'और दिखाएँ',
  'reviews.photo': 'रिव्यू फ़ोटो',
  'reviews.stars': '{n} स्टार',
  'reviews.end': 'बस इतने ही रिव्यू',
  'my.title': 'मेरे रिव्यू',
  'my.toRate': 'आपकी रेटिंग का इंतज़ार',
  'my.yours': 'आपके रिव्यू',
  'my.empty': 'अभी कोई रिव्यू नहीं',
  'my.emptyBody': 'डिलीवर हुए ऑर्डर को रेट करने के बाद आपकी रेटिंग यहाँ दिखेगी।',
  'my.status.held': 'जाँच में — अभी दिख नहीं रहा',
  'my.status.hidden': 'Capsico ने टेक्स्ट छिपाया — आपके स्टार गिने जाते हैं',
  'my.status.removed': 'रेटिंग से हटाया गया',
  'my.order': 'ऑर्डर #{number}',
  'account.reviews': 'मेरे रिव्यू',
  'restaurant.likes': '{count} को पसंद',
  /* W18: notifications + growth */
  'nav.inbox': 'सूचनाएँ',
  'inbox.title': 'सूचनाएँ',
  'inbox.bell': 'सूचनाएँ',
  'inbox.bellUnread': 'सूचनाएँ, {count} नई',
  'inbox.unreadCount': '{count} नई',
  'inbox.readAll': 'सब पढ़ा हुआ करें',
  'inbox.empty': 'अभी कोई सूचना नहीं',
  'inbox.emptyBody': 'ऑर्डर अपडेट, ऑफ़र और सपोर्ट के जवाब यहाँ आएँगे।',
  'inbox.loadMore': 'और देखें',
  'inbox.end': 'सब देख लिया ✨',
  'inbox.settings': 'सूचना सेटिंग्स',
  'inbox.signIn': 'अपनी सूचनाएँ देखने के लिए साइन इन करें',
  'inbox.failed': 'अपडेट नहीं हुआ। फिर से कोशिश करें।',
  'inbox.new': 'नई',
  'notify.cat.orders': 'ऑर्डर',
  'notify.cat.support': 'मदद और सपोर्ट',
  'notify.cat.account': 'अकाउंट और पैसे',
  'notify.cat.offers': 'ऑफ़र और डील',
  'notify.cat.reminders': 'रिमाइंडर',
  'prefs.title': 'सूचना सेटिंग्स',
  'prefs.categories': 'हम आपको किस बारे में बताएँ',
  'prefs.ordersHint': 'ऑर्डर अपडेट, डिलीवरी कोड, रिफ़ंड और सपोर्ट के जवाब',
  'prefs.ordersLocked': 'हमेशा चालू — खाना पाने के लिए ये ज़रूरी हैं',
  'prefs.offersHint': 'डील, नए रेस्टोरेंट और नए ऑफ़र',
  'prefs.remindersHint': 'कार्ट में छूटा सामान, ऑर्डर रेट करें',
  'prefs.channels': 'ऑफ़र और रिमाइंडर कहाँ भेजें',
  'prefs.channelsHint': 'ऑर्डर, सपोर्ट और अकाउंट के मैसेज हमेशा आप तक पहुँचते हैं।',
  'prefs.push': 'पुश नोटिफ़िकेशन',
  'prefs.sms': 'SMS',
  'prefs.whatsapp': 'WhatsApp',
  'prefs.saved': 'सूचना सेटिंग्स सेव हो गईं',
  'prefs.failed': 'सेव नहीं हुआ। फिर से कोशिश करें।',
  'prefs.quiet':
    'हम रात 10 बजे से सुबह 11 बजे तक ऑफ़र नहीं भेजते, और हफ़्ते में ज़्यादा से ज़्यादा 3।',
  'account.notifications': 'सूचनाएँ',
  'account.refer': 'रेफ़र करें और कमाएँ',
  'account.campus': 'कैंपस पास',
  'refer.title': 'रेफ़र करें और कमाएँ',
  'refer.hero': 'दोस्तों को बुलाएँ, हर एक पर {amount} कमाएँ 🎉',
  'refer.heroBody':
    'आपके दोस्त को पहले ऑर्डर पर {offer} मिलेगा। डिलीवर होते ही आपको {amount} Capsico Money मिलेगा।',
  'refer.heroBodyNoOffer': 'दोस्त का पहला ऑर्डर डिलीवर होते ही आपको {amount} Capsico Money मिलेगा।',
  'refer.yourCode': 'आपका कोड',
  'refer.copy': 'कॉपी',
  'refer.copied': 'कोड कॉपी हो गया',
  'refer.linkCopied': 'इनवाइट कॉपी हो गया — कहीं भी पेस्ट करें',
  'refer.share': 'इनवाइट शेयर करें',
  'refer.shareTitle': 'Capsico पर ऑर्डर करें',
  'refer.friendsJoined': 'जुड़े दोस्त',
  'refer.waiting': 'इंतज़ार में',
  'refer.earned': 'कमाया',
  'refer.monthCap': 'इस महीने {cap} में से {used} रिवॉर्ड इस्तेमाल हुए',
  'refer.history': 'आपके इनवाइट',
  'refer.noHistory': 'अभी कोई इनवाइट नहीं। शुरू करने के लिए अपना कोड शेयर करें।',
  'refer.status.pending': 'पहली डिलीवरी का इंतज़ार',
  'refer.status.rewarded': 'रिवॉर्ड मिला',
  'refer.status.blocked': 'रिवॉर्ड नहीं मिला',
  'refer.status.expired': 'समय खत्म',
  'refer.rules': 'यह कैसे काम करता है',
  'refer.rule1':
    'अपना कोड या लिंक उन दोस्तों से शेयर करें जिन्होंने Capsico पर कभी ऑर्डर नहीं किया।',
  'refer.rule2': 'आपके दोस्त को पहले ऑर्डर पर वेलकम ऑफ़र मिलता है।',
  'refer.rule3':
    'उनका पहला ऑर्डर डिलीवर होते ही आपको {amount} Capsico Money मिलता है। यह {days} दिन में खत्म हो जाता है।',
  'refer.rule4':
    'महीने में {cap} रिवॉर्ड तक। आपके जैसा ही फ़ोन, पता या पेमेंट अकाउंट गिना नहीं जाता।',
  'refer.haveCode': 'दोस्त का कोड है?',
  'refer.codeLabel': 'दोस्त, एम्बेसडर या क्रिएटर कोड',
  'refer.apply': 'लगाएँ',
  'growth.codeApplied': 'कोड {code} लग गया 🎉',
  'growth.offerReady': 'ऑफ़र {code} चेकआउट पर तैयार है 🎁',
  'campus.title': 'कैंपस पास',
  'campus.hero': 'कैंपस पर फ़्री डिलीवरी 🎓',
  'campus.heroBody':
    '{days} दिन तक आपके कैंपस से {km} km के अंदर फ़्री डिलीवरी। सिर्फ़ छात्रों के लिए।',
  'campus.pick': 'अपना कैंपस चुनें',
  'campus.distance': '{km} km दूर',
  'campus.freeWithin': '{km} km के अंदर फ़्री डिलीवरी',
  'campus.noCampus': 'आपके पास अभी कोई कैंपस नहीं',
  'campus.noCampusBody': 'कैंपस पास अभी कुछ कॉलेजों में है। हम और जोड़ रहे हैं।',
  'campus.useLocation': 'मेरे पास के कैंपस खोजें',
  'campus.locating': 'आपकी लोकेशन ढूँढ रहे हैं…',
  'campus.how': 'आप कैसे वेरिफ़ाई करना चाहेंगे?',
  'campus.methodEmail': 'कॉलेज ईमेल',
  'campus.methodEmailHint': 'हम आपके कॉलेज ईमेल पर 6 अंकों का कोड भेजेंगे',
  'campus.methodPhoto': 'स्टूडेंट ID फ़ोटो',
  'campus.methodPhotoHint': 'हमारी टीम जाँचती है, आमतौर पर एक दिन में',
  'campus.email': 'कॉलेज ईमेल',
  'campus.emailHint': '{domains} पर खत्म होना चाहिए',
  'campus.emailBad': 'अपना कॉलेज ईमेल पता डालें',
  'campus.ambassador': 'एम्बेसडर कोड (वैकल्पिक)',
  'campus.sendCode': 'कोड भेजें',
  'campus.continue': 'आगे बढ़ें',
  'campus.sent': 'कोड आपके कॉलेज ईमेल पर भेज दिया 📧',
  'campus.codeTitle': 'अपना कॉलेज ईमेल देखें',
  'campus.codeBody': '{email} पर भेजा गया 6 अंकों का कोड डालें।',
  'campus.code': '6 अंकों का कोड',
  'campus.verify': 'वेरिफ़ाई करें',
  'campus.verified': 'कैंपस पास चालू हो गया 🎉',
  'campus.startOver': 'फिर से शुरू करें',
  'campus.photoTitle': 'अपना स्टूडेंट ID अपलोड करें',
  'campus.photoBody': 'सामने की साफ़ फ़ोटो, जिसमें आपका नाम और कॉलेज दिखे।',
  'campus.photoPick': 'फ़ोटो जोड़ें',
  'campus.photoReplace': 'बदलें',
  'campus.photoRemove': 'हटाएँ',
  'campus.photoUpload': 'जाँच के लिए भेजें',
  'campus.photoUploading': 'अपलोड हो रहा है {percent}%',
  'campus.photoTooBig': 'फ़ोटो 8 MB से छोटी JPG, PNG या WebP होनी चाहिए',
  'campus.uploaded': 'ID भेज दी — हम जल्द जाँचेंगे',
  'campus.failed': 'कुछ गड़बड़ हुई। फिर से कोशिश करें।',
  'campus.status.pending_email': 'अपना कॉलेज ईमेल देखें',
  'campus.status.pending_photo': 'अपना ID कार्ड अपलोड करें',
  'campus.status.pending_review': 'जाँच चल रही है',
  'campus.status.active': 'चालू',
  'campus.status.rejected': 'मंज़ूर नहीं हुआ',
  'campus.status.expired': 'समय खत्म',
  'campus.activeBody': '{campus} से {km} km के अंदर फ़्री डिलीवरी।',
  'campus.validUntil': '{date} तक मान्य',
  'campus.reviewBody': 'हम {campus} के लिए आपकी ID जाँच रहे हैं। हम आपको बताएँगे।',
  'campus.rejectedBody': 'कारण: {reason}',
  'campus.tryAgain': 'फिर से अप्लाई करें',
  'campus.expiredBody': '{campus} का आपका पास खत्म हो गया। रिन्यू करने के लिए फिर से अप्लाई करें।',
  'cashback.orderEarned': 'इस ऑर्डर पर आपको {amount} कैशबैक मिला 🎉',
  'cashback.expires': 'Capsico Money में जुड़ा · {date} को खत्म',
  'cashback.hint': 'इस ऑर्डर पर {percent}% कैशबैक 🎉',
  'cashback.hintBody': 'डिलीवरी के बाद लगभग {amount} Capsico Money में वापस।',
  'cashback.walletTitle': 'मिला कैशबैक',
  'cashback.walletTotal': 'योग्य ऑर्डर पर {percent}% से अब तक {amount}',
  'cashback.order': 'ऑर्डर #{number}',
  'cashback.orderNoNumber': 'ऑर्डर',
  'winback.title': 'वापसी पर स्वागत है! 🎁',
  'winback.body': '{amount} Capsico Money आपका इंतज़ार कर रहा है — {date} से पहले इस्तेमाल करें।',
  'deeplink.opening': 'खुल रहा है…',
  'legal.title': 'कानूनी',
  'legal.terms': 'उपयोग की शर्तें',
  'legal.privacy': 'गोपनीयता नीति',
  'legal.refunds': 'रिफंड और कैंसलेशन',
  'legal.cookies': 'कुकी सूचना',
  'legal.restaurantTerms': 'रेस्टोरेंट पार्टनर की शर्तें',
  'legal.riderTerms': 'डिलीवरी पार्टनर की शर्तें',
  'legal.grievance': 'शिकायत अधिकारी',
  'legal.openSite': 'capsicoeats.com पर खोलें',
  'legal.loadFailed': 'यह दस्तावेज़ लोड नहीं हो सका',
  'legal.loadFailedBody': 'अपना इंटरनेट देखें, या इसे हमारी वेबसाइट पर पढ़ें।',
  'legal.version': 'संस्करण {version}',
  'legal.reconsentTitle': 'हमने अपनी शर्तें अपडेट की हैं 📄',
  'legal.reconsentBody': 'क्या बदला है, पढ़ें और Capsico इस्तेमाल करते रहने के लिए स्वीकार करें।',
  'legal.whatChanged': 'क्या बदला',
  'legal.read': 'पूरा दस्तावेज़ पढ़ें',
  'legal.hide': 'दस्तावेज़ छिपाएँ',
  'legal.agree': 'मैंने अपडेट किए गए दस्तावेज़ पढ़ लिए हैं और मैं सहमत हूँ',
  'legal.accept': 'स्वीकार करें और आगे बढ़ें',
  'legal.acceptFailed': 'आपकी स्वीकृति सेव नहीं हो सकी। फिर से कोशिश करें।',
  'legal.signOut': 'इसके बजाय साइन आउट करें',
  'update.requiredTitle': 'कृपया ऐप अपडेट करें',
  'update.requiredBody':
    'यह संस्करण अब सपोर्ट नहीं होता। Capsico इस्तेमाल करते रहने के लिए ऐप अपडेट करें।',
  'update.availableTitle': 'नया संस्करण आ गया है',
  'update.availableBody': 'नए सुधार और फ़ीचर पाने के लिए अपडेट करें।',
  'update.version': 'संस्करण {version}',
  'update.notes': 'नया क्या है',
  'update.now': 'अभी अपडेट करें',
  'update.update': 'अपडेट करें',
  'update.reload': 'फिर से लोड करें',
  'update.later': 'बाद में',
  'integrity.title': 'Play Store से Capsico इंस्टॉल करें',
  'integrity.body':
    'हम ऐप की इस कॉपी की पुष्टि नहीं कर पाए। ऑर्डर और पेमेंट के लिए Google Play से असली Capsico ऐप इंस्टॉल करें।',
  'integrity.openStore': 'Play Store खोलें',
  'integrity.retry': 'फिर से कोशिश करें',
};
